/**
 * Column API Service
 * Handles all column-related API calls
 */

import axiosClient from '../../../api/axiosClient';
import { Column, CreateColumnDTO, UpdateColumnDTO } from '../model/types';

export const columnService = {
  /**
   * Get all columns for a specific board
   */
  getColumnsForBoard: async (boardId: number): Promise<Column[]> => {
    const response = await axiosClient.get(`/boards/${boardId}/columns`);
    return response.data;
  },

  /**
   * Get a specific column by ID
   */
  getColumn: async (columnId: number): Promise<Column> => {
    const response = await axiosClient.get(`/columns/${columnId}`);
    return response.data;
  },

  /**
   * Create a new column
   */
  createColumn: async (columnData: CreateColumnDTO): Promise<Column> => {
    const response = await axiosClient.post('/columns', columnData);
    return response.data;
  },

  /**
   * Update an existing column
   */
  updateColumn: async (columnId: number, updates: UpdateColumnDTO): Promise<Column> => {
    const response = await axiosClient.put(`/columns/${columnId}`, updates);
    return response.data;
  },

  /**
   * Delete a column
   */
  deleteColumn: async (columnId: number): Promise<void> => {
    await axiosClient.delete(`/columns/${columnId}`);
  },

  /**
   * Reorder columns on a board
   */
  reorderColumns: async (boardId: number, columnIds: number[]): Promise<Column[]> => {
    const response = await axiosClient.put(`/boards/${boardId}/columns/reorder`, {
      columnIds,
    });
    return response.data;
  },
};

export default columnService;
